import React from 'react';
import { Sparkles } from 'lucide-react';

const HeroSection = () => {
  const scrollToPricing = () => {
    // Track Google Ads conversion for viewing offers
    if (window.gtag) {
      window.gtag('event', 'view_promotion', {
        'promotion_id': 'happy_hour_offers',
        'promotion_name': 'Happy Hour Special Prices'
      });
    }
    
    // Scroll to pricing section
    const pricingSection = document.querySelector('.pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <header className="site-header">
        <h1 className="brand-logo">O2 Nails Hyd</h1>
      </header>
      
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-message">
            <h1 className="hero-headline">
              We Only Do Nails. And We Do Them Right.
            </h1>
            <h2 className="hero-subtext">
              Skip the crowded beauty parlors. Step into O2 Nails Hyd for master-level gel polish, luxury extensions, and 100% focus on your hands.
            </h2>
            
            <button onClick={scrollToPricing} className="hero-cta-button">
              <Sparkles className="cta-sparkle" />
              <span>View Today's Offers</span>
              <Sparkles className="cta-sparkle" />
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
